import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_HEADER_HEIGHT } from '@core/components/header/header.model';
import { IS_MOBILE, IS_MOBILE_PROVIDER } from '@core/injection-tokens/is-mobile';
import { AccountService } from '@core/services/account.service';
import { NotificationsCenterService } from '@core/services/notifications-center.service';
import { StorageService } from '@core/services/storage/storage.service';
import { UnsubscribeService } from '@core/services/unsubscribe.service';
import { Account, NavItem } from '@shared/models';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationArea } from 'src/app/portal/portal.model';

@Component({
  selector: 'gcc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [IS_MOBILE_PROVIDER]
})
export class HeaderComponent implements OnInit {
  get view() {
    const pathname = this.router.url.split('?')[0];

    if (pathname.includes('admin')) {
      return 'admin';
    }
    if (pathname.includes('error')) {
      return 'error';
    }
    return 'portal';
  }

  get navItems() {
    switch (this.view) {
      case 'admin':
        return this.adminNavigation;
      case 'portal':
        return this.portalNavigation;
      default:
        return [];
    }
  }

  public user$: Observable<Account>;
  public applicationArea = ApplicationArea;
  public isShowNotifications = false;

  @ViewChild('header', { static: false }) public header: ElementRef;
  private countRepeat = 5;

  private adminNavigation: NavItem[] = [
    {
      title: 'Alerts & Notifications',
      path: '/admin/alerts&notifications',
      exact: true
    },
    {
      title: 'Users',
      path: '/admin/users',
      exact: true
    },
    {
      title: 'Tree Builder',
      path: '/admin/tree_builder',
      exact: false
    },
    {
      title: 'Reports',
      path: '/admin/reports',
      exact: false
    },
    {
      title: 'Popular Solutions',
      path: '/admin/settings',
      exact: false
    }
  ];

  private portalNavigation: NavItem[] = [];

  constructor(
    @Inject(IS_MOBILE) public isMobile: boolean,
    private accountService: AccountService,
    private notificationCenterService: NotificationsCenterService,
    private unsubscribe$: UnsubscribeService,
    private storage: StorageService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.user$ = this.accountService.account$;

    this.watchForNotifications();
  }

  public onLogout() {
    this.accountService.logout();
  }

  public checkGrantedForNonMemberFirmUser() {
    // Grant access to application for non member firm users
    if (this.view === 'error' && !this.storage.accessGrantedForNonMemberFirmUser) {
      this.storage.accessGrantedForNonMemberFirmUser = true;
    }
  }

  private watchForNotifications(): void {
    this.notificationCenterService.urgentAlerts$.pipe(takeUntil(this.unsubscribe$)).subscribe(urgentAlerts => {
      if (urgentAlerts.length) {
        if (this.countRepeat) {
          this.notificationCenterService.getUrl(true);
          this.countRepeat--;
        }
        setTimeout(() => {
          this.notificationCenterService.setNotificationsAndHeaderHeight(this.header.nativeElement.offsetHeight);
        }, 0);
      } else {
        this.notificationCenterService.setNotificationsAndHeaderHeight(DEFAULT_HEADER_HEIGHT);
      }
    });

    this.notificationCenterService.isShowNotifications$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(isShowNotifications => (this.isShowNotifications = isShowNotifications));
  }
}
